import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userName: localStorage.getItem("userName") || "",
    token: localStorage.getItem("token") || "",
  },
  getters: {
    //是否登录
    isLogin(state) {
      return state.token;
    },
    isAdmin(state) {
      return state.userName === "admin";
    },
    userName(state) {
      return state.userName;
    },
  },
  mutations: {
    login(state, data) {
      state.token = data.token;
      state.userName = data.username;
      localStorage.setItem("token", data.token);
      localStorage.setItem("userName", data.username);
    },
    logout(state) {
      state.token = "";
      state.userName = "";
      localStorage.setItem("token", "");
      localStorage.setItem("userName", "");
    },
  },
  actions: {},
});
